export let Currency = /*#__PURE__*/function (Currency) {
  Currency["EUR"] = "eur";
  Currency["USD"] = "usd";
  Currency["GBP"] = "gbp";
  Currency["AUD"] = "aud";
  return Currency;
}({});